require("!!/home/ubuntu/nflow/node_modules/script-loader/addScript.js")(require("!!/home/ubuntu/nflow/node_modules/raw-loader/index.js!/home/ubuntu/nflow/node_modules/mocha/mocha.js")+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///home/ubuntu/nflow/node_modules/mocha/mocha.js")


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/mocha/mocha.js
// module id = 94
// module chunks = 3